import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function OsnoviKompanijskogPrava() {
  return (
    <>
      <Navbar />
      <Bredcom
        title="Početna"
        subtitle="Osnovi kompanijskog prava i trgovinsko pravo"
      />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">
                Osnovi kompanijskog prava i trgovinsko pravo
              </h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Osnovi kompanijskog prava i
                trgovinsko pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Ciljevi predmeta Osnovi kompanijskog i trgovinsko pravo su
                upoznavanje studenata sa opštim znanjem o pojmu, sistematici,
                metodama i izvorima kompanijskog prava; načelima regulisanja
                kompanijskog prava; subjektima kompanijskog prava, njihovom
                osnivanju, povezivanju, zastupanju, reorganizaciji i prestanku;
                individualizaciji i dr. Upoznavanje studenata sa osnovnim
                pravnim pojmovima, institutima i pravilima iz oblasti
                trgovinskog prava, uključujući bitne elemente kao što je
                sklapanje ugovora, njegovo tumačenje, aneks ugovora, ugovorna
                odgovornost i prestanak ugovornog odnosa. Takođe cilj ovog
                predmeta je i izučavanje najznačajnijih pojedinačnih ugovora i
                njihovih karakteristika, kao i bankarskih poslova i hartija od
                vrijednosti.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Ishod predmeta je da svojim programskim sadržajem obezbijedi
                studentima neophodna teoretska znanja o suštini kompanijskog
                prava i njegovim osnovnim pojmovima. Sticanje osnovnih i opštih
                znanja u domenu kompanijskog prava sa naglaskom na statusno
                kompanijsko pravo i osvrtom na evropske privredno-pravne aspekte
                modernog poslovanja - uputstva kompanijskog prava Evropske
                unije. Studenti će nakon izučavanja ove grane prava i položenog
                ispita steći znanja i vještine da samostalno sa pravnog aspekta
                osnivaju, organizuju, rukovode i zastupaju bilo koji oblik
                privrednog društva, kao i da zaključuju ugovore iz domena
                privrede i trgovine. Student će ovladati tehnikom pregovaranja,
                sačinjavanja i tumačenja ugovora trgovinskog prava.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
                <br />
                Kompanijsko pravo: Pojam, predmet i izvori kompanijskog prava;
                Odnos kompanijskog prava sa drugim granama prava; Pravni
                subjektivitet privrednih društava; Sistemi za osnivanje
                privrednih društava; Obilježja i klasifikacija privrednih
                društava; Preduzetnik; Ortačko društvo; Komaditno društvo;
                Društvo sa ograničenom odgovornošću; Akcionarsko društvo;
                Privredne asocijacije, povezivanje i reorganizacija privrednih
                društava; Odgovornost za preuzete obaveze u pravnom prometu;
                Restruktuiranje i prestanak privrednih društava. Trgovinsko
                pravo: Pojam, predmet i izvori trgovinskog prava; Opšta pravila
                trgovinskih poslova; Specifičnosti ugovora u privredi; Ugovor o
                prodaji; Ugovori sa građanskopravnom osnovom u ugovoru o nalogu;
                Ugovori sa građanskopravnom osnovu u ugovoru o djelu; Ugovori sa
                mješovitom građanskopravnom osnovu; Pojam, osobine i vrste
                bankarskih poslova; Kreditni poslovi i posebni poslovi
                finansiranja; Bankarski uslužni poslovi; Pojam, karakteristike i
                klasifikacija hartija od vrijednosti; Pojam, vrste i bitni
                elementi mjenice; Mjenične radnje; Pojam, vrste i elementi čeka;
                Čekovne radnje; Robne hartije od vrijednosti; Konosman i
                teretnica; Legitimacione isprave.
              </p>
              <p>
                <strong>Praktična nastava:</strong>
                <br />
                Praktična nastava će se organizovati kako na fakultetu tako i
                posjetama državnim institucijama i privatnim kompanijama. Na
                časovima predavanja i vježbi studenti će imati aktivnu ulogu
                kroz raznorazne debate i studije slučaja. Takođe, analiziraće se
                stručna praksa i primjeri iz prakse.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja, interaktivni oblici nastave, analiza slučajeva,
                individualni i grupni projekti.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam, predmet i izvori Kompanijskog prava; Odnos
                      Kompanijskog prava sa drugim granama prava; Pravni
                      subjektivitet privrednih društava;
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Sistemi za osnivanje privrednih društava; Obilježja i
                      klasifikacija privrednih društava; Preduzetnik;
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Ortačko društvo; Komaditno društvo; Društvo sa ograničenom
                      odgovornošću;
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Akcionarsko društvo; Praktična nastava. Posjeta privatnim
                      kompanijama i analiza.
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Privredne asocijacije, povezivanje i reorganizacija
                      privrednih društava; Odgovornost za preuzete obaveze u
                      pravnom prometu; Restruktuiranje i prestanak privrednih
                      društava; Praktična nastava. Posjeta Privrednom sudu.
                      Analiza sudske prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam, predmet i izvori Trgovinskog prava; Opšta pravila
                      trgovinskih poslova; Specifičnosti ugovora u privredi;
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>Ugovor o prodaji;</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>
                      Ugovori sa građanskopravnom osnovom u ugovoru o nalogu;
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>
                      Ugovori sa građanskopravnom osnovu u ugovoru o djelu;
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      Ugovori sa mješovitom građanskopravnom osnovu; Praktična
                      nastava. Sastavljanje ugovora. Posjeta Luci Bar.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam, osobine i vrste bankarskih poslova; Kreditni
                      poslovi i posebni poslovi finansiranja; Bankarski uslužni
                      poslovi;
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>
                      Pojam, karakteristike i klasifikacija hartija od
                      vrijednosti; Pojam, vrste i bitni elementi mjenice;
                      Mjenične radnje; Pojam, vrste i elementi čeka; Čekovne
                      radnje;
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Robne hartije od vrijednosti; Konosman i teretnica;
                      Legitimacione isprave; Praktična nastava. Posjeta
                      komercijalnim bankama. Analiza primjera iz prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5č / 3.45h</td>
                            <td>Ukupno: 90h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3č / 2.15h</td>
                            <td>Nastava + završni ispit: 65h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 10h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default OsnoviKompanijskogPrava;
